
var ReactDOM = require('react-dom');
var React = require('react');
import * as ReactRedux from 'react-redux';
import Actions from './Actions';
import OnlineStatus from './classes/OnlineStatus'
import bootstrap from '../css/bootstrap.min.less'
import css from '../css/combined.less'

class App {

	constructor() {
		this.onlineStatus = new OnlineStatus();
	}

	run(containerId, initialState, stateScope = '') {

		if (window.actions === undefined) {
			window.actions = new Actions(initialState);
		} else {
			window.actions.addInitialState(stateScope, initialState);
		}

		var view = "NotFound";
		if (initialState.view !== undefined) {
			view = initialState.view;
		}

		var context = require.context('bundle-loader!./views', true, /\.js$/);
		context("./" + view + '.js')(function (View) {
			ReactDOM.hydrate(
				<ReactRedux.Provider store={actions.store}>
					<View.default containerId={containerId} />
				</ReactRedux.Provider>,
				document.getElementById(containerId)
			);
		});
	}

}

$(function () {
	$("#priceChangeClicked").click(function () {
		let name = "price_change_info"
		let value = "1"
		let date = new Date()
		let days = 30
		date.setTime(date.getTime() + (days*24*60*60*1000))
		let expires = "; expires="+date.toGMTString()
		document.cookie = name+"="+value+expires+"; path=/"
	})
})

window.App = new App();




// WEBPACK FOOTER //
// ./jsx/app.js